import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import useDrive from "../../hooks/useDrive";
import useNotification from "../../hooks/useNotification";
import DriveService from "../../services/DriveService";

export default function FolderRenameDialog() {
    const { renameFolder, changeRenameFolder, CurrentDrive, changeCurrentDrive } = useDrive();
    const { addNotification } = useNotification();

    const handleClose = () => changeRenameFolder(null);

    const handleSubmit = async event => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const name = data.get('folderName').trim();
        const { parent } = CurrentDrive;
        if (name) {
            let params = { folder: parent + "/" + renameFolder.Key, folder_new: parent + "/" + name };
            if ((parent !== "/" && parent === "") || !parent) {
                params = { folder: renameFolder.Key, folder_new: name };
            }
            params["driveType"] = CurrentDrive.driveType;
            if (params.folder !== params.folder_new) {
                await DriveService.rename(params);
                addNotification({ type: "success", message: "Folder renamed successfully" });
            }
            changeRenameFolder(null);
            const drive = await DriveService.getFileTree(parent);
            changeCurrentDrive({ parent, drive });
        }
    };

    return (
        <Dialog
            open={!!renameFolder}
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    bgcolor: '#111328',
                    border: '1px solid rgba(255,255,255,0.08)',
                    borderRadius: 3,
                    boxShadow: '0 24px 60px rgba(0,0,0,0.6)',
                }
            }}
        >
            <form onSubmit={handleSubmit}>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
                    <DriveFileRenameOutlineIcon sx={{ color: '#fff', fontSize: 20 }} />
                    <Typography sx={{ color: '#fff', fontWeight: 600, fontSize: 16, flex: 1 }}>
                        Rename Folder
                    </Typography>
                    <IconButton size="small" onClick={handleClose} sx={{ color: 'rgba(255,255,255,0.4)', '&:hover': { color: '#fff' } }}>
                        <CloseIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ pt: 1, pb: 2 }}>
                    <TextField
                        name="folderName"
                        fullWidth
                        autoFocus
                        required
                        placeholder="Enter new name"
                        defaultValue={renameFolder?.Key || ''}
                        variant="outlined"
                        sx={{
                            mt: 1,
                            '& .MuiOutlinedInput-root': {
                                color: '#fff',
                                borderRadius: 2,
                                bgcolor: 'rgba(255,255,255,0.04)',
                                '& fieldset': { borderColor: 'rgba(255,255,255,0.12)' },
                                '&:hover fieldset': { borderColor: '#fff' },
                                '&.Mui-focused fieldset': { borderColor: '#fff', borderWidth: 1 },
                            },
                            '& .MuiInputBase-input::placeholder': { color: 'rgba(255,255,255,0.3)', opacity: 1 },
                        }}
                    />
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
                    <Button
                        onClick={handleClose}
                        sx={{
                            color: 'rgba(255,255,255,0.5)', textTransform: 'none', fontWeight: 500,
                            '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.06)' },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        sx={{
                            textTransform: 'none', fontWeight: 600, px: 3, borderRadius: 2,
                            bgcolor: '#fff', color: '#111328',
                            '&:hover': { bgcolor: 'rgba(255,255,255,0.88)' },
                        }}
                    >
                        Rename
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
